import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createElementBlock as _createElementBlock, createElementVNode as _createElementVNode, renderSlot as _renderSlot, normalizeClass as _normalizeClass, vShow as _vShow, withDirectives as _withDirectives, Transition as _Transition, withCtx as _withCtx, createVNode as _createVNode, Fragment as _Fragment } from "vue"

const _hoisted_1 = { class: "flex flex-col items-start" }
const _hoisted_2 = {
  key: 0,
  class: "text-gray-800 font-medium"
}
const _hoisted_3 = {
  key: 1,
  class: "text-gray-700 text-sm truncate"
}
const _hoisted_4 = { class: "flex-1" }

import { PropType, ref, watch } from 'vue';
import { BaseIcon } from '@/lib/components/Icon';
import { AccordionTabColor, PositionName } from '@/lib';


export default /*@__PURE__*/_defineComponent({
  __name: 'Accordion',
  props: {
  title: {
    type: String,
    required: true
  },
  subtitle: {
    type: String,
    default: null
  },
  caretPosition: {
    type: String as PropType<PositionName>,
    default: 'right',
    validator: (value: string) => ['left', 'right'].includes(value)
  },
  disableClick: {
    type: Boolean,
    default: false
  },
  tabColor: {
    type: String,
    default: 'white',
    validator: (value: AccordionTabColor) =>
      [
        'white',
        'primary-200'
      ].includes(value)
  },
  contentClass: {
    type: String,
    default: 'white'
  },
  isOpen: {
    type: Boolean
  }
},
  emits: ['update:isOpen'],
  setup(__props, { emit: __emit }) {

const props=__props;

watch(() => props.isOpen, () => {
  localOpen.value = props.isOpen;
});

const emit = __emit;

const localOpen = ref(props.isOpen);
const toggleAccordion = () => {
  if (props.disableClick) {
    return;
  }
  emit('update:isOpen', !props.isOpen);
  localOpen.value = !localOpen.value;
};

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", {
      class: _normalizeClass(["flex flex-row justify-between items-center border border-solid border-gray-300 rounded-t-lg shadow p-4", [`bg-${__props.tabColor}`, `${localOpen.value? 'rounded-b-none':'rounded-b-lg'}`, `${__props.disableClick ? 'cursor-default' : 'cursor-pointer'}`]]),
      onClick: _cache[0] || (_cache[0] = ($event: any) => (toggleAccordion()))
    }, [
      (__props.caretPosition === 'left')
        ? (_openBlock(), _createBlock(_unref(BaseIcon), {
            key: 0,
            name: localOpen.value ? 'chevron-down' : 'chevron-right',
            height: "1.5em",
            position: "left",
            class: "mr-2"
          }, null, 8, ["name"]))
        : _createCommentVNode("", true),
      _createElementVNode("div", _hoisted_1, [
        (__props.title)
          ? (_openBlock(), _createElementBlock("span", _hoisted_2, _toDisplayString(__props.title), 1))
          : _createCommentVNode("", true),
        (__props.subtitle)
          ? (_openBlock(), _createElementBlock("span", _hoisted_3, _toDisplayString(__props.subtitle), 1))
          : _createCommentVNode("", true)
      ]),
      _createElementVNode("div", _hoisted_4, [
        _renderSlot(_ctx.$slots, "tab-col")
      ]),
      (__props.caretPosition === 'right')
        ? (_openBlock(), _createBlock(_unref(BaseIcon), {
            key: 1,
            name: localOpen.value ? 'chevron-down' : 'chevron-right',
            height: "1.5em",
            position: "right"
          }, null, 8, ["name"]))
        : _createCommentVNode("", true)
    ], 2),
    _createVNode(_Transition, {
      "enter-active-class": "accordion-maxheight-enter-active",
      "leave-active-class": "accordion-maxheight-leave-active",
      "enter-from-class": "accordion-maxheight-enter-from",
      "enter-to-class": "accordion-maxheight-enter-to",
      "leave-from-class": "accordion-maxheight-leave-from",
      "leave-to-class": "accordion-maxheight-leave-to"
    }, {
      default: _withCtx(() => [
        _withDirectives(_createElementVNode("div", {
          id: "accordion-content",
          class: _normalizeClass(["border-l border-b border-r border-solid border-gray-300 rounded-b-lg shadow overflow-hidden", `${__props.contentClass}`])
        }, [
          _createElementVNode("div", null, [
            _renderSlot(_ctx.$slots, "contents")
          ])
        ], 2), [
          [_vShow, localOpen.value]
        ])
      ]),
      _: 3
    })
  ], 64))
}
}

})